import { IDocumentSearchField } from "../../interfaces/advancedSearch/IDocumentSearchField";

export class KeyValuePairHelper {
    static buildKeyValuePairs(nameValuePair: IDocumentSearchField[]) {
        let obj = {};
        nameValuePair.forEach(field => {
            obj[field.name] = field;
        });

        return obj;
    };
}